import Vue from 'vue';

export default new Vue({
  methods: {
    fire(event, data = null) {
      this.$emit(event, data);
    },

    listen(event, callback) {
      this.$on(event, callback);
    },
  },
});
